/**
 * ObjectNumberField React component
 * 
 * @author    Maurizio Tidei, Jens Gruschel
 * @copyright © 2019 contexagon GmbH
 */


// React
import React from 'react';
import PropTypes from 'prop-types';

// Material UI
import {withStyles} from "@material-ui/core";

// Material UI components
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';


/**
 * ObjectNumberField is an editing component for numeric fields of objects
 *
 * @author Maurizio Tidei, Jens Gruschel
 */
export class ObjectNumberField extends React.Component {

    handleChange = id => event => {
        const value = event.target.value === "" ? undefined : event.target.value;
        this.props.onObjectValueChange(id, value);
    };

    validateNumber(acceptMissing) {
        if (this.props.value == null || this.props.value === "") {
            return acceptMissing || !this.props.fieldDef.mandatory;
        }
        else if (this.props.fieldDef.type === "int") {
            // convert to number and check "isInteger" is more strict as "parseInt" (latter allows values like "1A")
            return Number.isInteger(Number(this.props.value));
        }
        else {
            return !isNaN(this.props.value);
        }
    }

    render() {

        const { classes, fieldDef } = this.props;

        let inputProps = {
            readOnly: this.props.readOnly
        };

        // add a select for the suffixes, if present
        if (fieldDef.suffixes) {
            inputProps.endAdornment = this.createSuffixAdornment();
        }

        return <TextField
            className={classes.numberField}
            id={fieldDef.id}
            label={fieldDef.name}
            value={this.props.value != null ? this.props.value : ""}
            disabled={this.props.readOnly} // TODO: make text selectable for copy/paste
            required={fieldDef.mandatory}
            error={!this.validateNumber(true)}
            onChange={this.handleChange(fieldDef.id)}
            margin="normal"
            fullWidth={true}
            type="text" // "number" seems to infere validation, maybe because non-digit characters are absorbed
            helperText={fieldDef.note}
            InputProps={inputProps}
        />;
    }

    createSuffixAdornment() {

        const { classes, fieldDef } = this.props;

        return <InputAdornment position="end">
            <Select
                value={this.props.suffix || fieldDef.defaultsuffix || fieldDef.suffixes[0] || ''}
                disabled={this.props.readOnly}
                className={classes.suffix}
                disableUnderline={true}
                onChange={this.handleChange(fieldDef.id + '__suffix', false)}
            >
                {fieldDef.suffixes.map((suffix, i) => {
                    return <MenuItem key={suffix} value={suffix}>{suffix}</MenuItem>
                })}
            </Select>
        </InputAdornment>;
    }
}

ObjectNumberField.propTypes = {
    onObjectValueChange: PropTypes.func.isRequired,
    fieldDef: PropTypes.object.isRequired,
    objectId: PropTypes.string,
    readOnly: PropTypes.bool,
    value: PropTypes.any
};

const styles = {
    suffix: {
        color: '#666666'
    },
    numberField: {
        // red star for mandatory fields
        "& label span": {
            color: "#FF0000"
        }
    }
};

export default withStyles(styles)(ObjectNumberField);